import React from 'react';
import './PendingModule.scss'
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export interface PendingModuleProps {
    moduleName: string;
    moduleLink: string;
}

const PendingModule: React.FC<PendingModuleProps> = (props) => {

    // const history = useHistory();
    const navigate = useNavigate()

    function redirectToUrl() {
        // history.push(props.moduleLink);
        navigate(props.moduleLink)
    }

    return (
        <button type='button' className='pendingModule' onClick={redirectToUrl}>
            <span className="edel-icon-back-arrow" aria-hidden="true" />
            <span className='pmName'>
                {props.moduleName}
            </span>
        </button>
    );
}

export default PendingModule;